import { isThisHour, isToday, parseISO } from 'date-fns';
import {
  StatisticValue,
  StatisticLabel,
  StatisticGroup,
  Statistic,
} from 'semantic-ui-react';

const JobStatistics = ({ jobs }) => {
  if (!jobs) return null;
  return (
    <div>
      <StatisticGroup>
        <Statistic>
          <StatisticValue>{jobs.length}</StatisticValue>
          <StatisticLabel>Total Active Jobs</StatisticLabel>
        </Statistic>
        <Statistic>
          <StatisticValue>
            {
              jobs.filter((job) => isToday(parseISO(job.nextInvocationTime)))
                .length
            }
          </StatisticValue>
          <StatisticLabel>Today's Jobs</StatisticLabel>
        </Statistic>
        <Statistic>
          <StatisticValue>
            {
              jobs.filter((job) => isThisHour(parseISO(job.nextInvocationTime)))
                .length
            }
          </StatisticValue>
          <StatisticLabel>Jobs in this Hour</StatisticLabel>
        </Statistic>
      </StatisticGroup>
    </div>
  );
};

export default JobStatistics;
